import { useState } from 'react';
import { faqItems } from '@/mocks/site';

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">
            关于亚洲精品一区二区的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.slice(0, 5).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggle(idx)}
              >
                <span className="font-heading font-semibold text-foreground-900 text-sm pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}